import axios from 'axios';

async function getAppVersion() {
    return axios.get('/General/AppVersion/');
}

// spec 000264 (revision 2) — the live load-group minimum (General.LoadGroup.MinChargingCurrentAmps), { amps, watts }.
async function getLoadGroupMinChargingCurrent() {
    return axios.get('/General/LoadGroupMinChargingCurrent/');
}

async function getLandingPageUrl() {
    return axios.get('/General/LandingPageUrl/');
}

const generalService = {
    getAppVersion,
    getLandingPageUrl,
    getLoadGroupMinChargingCurrent
}

export default generalService;